<script>
import { TOKEN_SESSION, USER, TOAST_MESSAGE } from './stores'
import Login from './components/Login.svelte'
import Main from './components/Main.svelte'
import * as Fx from './globals/Fx'
import { onMount } from 'svelte';


onMount(async () => {
	const token = Fx._retrieveData("token")
	console.log("token >>", token)
	TOKEN_SESSION.set(token)
});


let toastMessage
let toastColor
let ACTUALTOKEN 

$: {
		ACTUALTOKEN= $TOKEN_SESSION
		console.log(ACTUALTOKEN)
	}

$: $TOAST_MESSAGE && mostrarToast(($TOAST_MESSAGE))

const mostrarToast = (json) => {
    var toastHHTMLElement = document.getElementById('liveToast')
	var toastElement = new bootstrap.Toast(toastHHTMLElement,{})
	const {result, message} = json
	toastMessage = message
	toastColor = result === "error" ? "bg-danger-x" : "bg-success-x"
	toastElement.show()
}

const validateLogin = (event) => {
	const {result, message, token, usu_nombre, usu_email, usu_id} = event.detail.json
	if (result === "error") {
		TOKEN_SESSION.set(0)
	}else{
		TOKEN_SESSION.set(token)
		USER.set({usu_nombre,usu_email, usu_id})
		Fx._store("token", token)
		Fx._store("userInfo", JSON.stringify({usu_nombre,usu_email, usu_id}))
	}
}

const closeSession = () => {
	TOKEN_SESSION.set(0)
	Fx._deleteKey("token")
	ACTUALTOKEN = null
}



</script>

<div>
	{#if ACTUALTOKEN }
		<Main 
			on:closeSession={closeSession}
		/>
	{:else}
		<Login 
			on:validateResult={validateLogin}
		/>
	{/if}
	
	<!-- DEFINICIÓN LOCAL DEL TOAST-->
	<div class="position-fixed bottom-0 end-0 p-3 " style="z-index: 2000">
		<div id="liveToast" class="toast hide {toastColor} text-white" role="alert" aria-live="assertive" aria-atomic="true">
		<div class="toast-header {toastColor} text-white">
			<strong class="me-auto">Mensaje Reciente</strong>
			<small>Mensaje</small>
			<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
		</div>
		<div class="toast-body">
			{toastMessage}
		</div>
		</div>
	</div>
	<!-- DEFINICIÓN LOCAL DEL TOAST-->
</div>

<style>
    .bg-success-x {
        background-color: #19875488;    
    }
    .bg-danger-x {
        background-color: #ff634788;    
    }
</style>